<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="email-signatures-card">
    <EcsEmailSignaturesHeader />
    <div class="d-flex flex-row flex-wrap justify-space-around">
      <EcsEmailSignature
        quill-id="signature"
        :title="$t('signature')"
        :subtitle="$t('signatureSubtitle')"
        :quillValue="signature"
        :onQuillChange="onSignatureChange"
      />
      <EcsEmailSignature
        quill-id="reply"
        :title="$t('replySignature')"
        :subtitle="$t('replySignatureSubtitle')"
        :quillValue="replySignature"
        :onQuillChange="onReplySignatureChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EcsEmailSignature from '@/components/ecs-email-signatures/EcsEmailSignature';
import EcsEmailSignaturesHeader from '@/components/ecs-email-signatures/EcsEmailSignaturesHeader';
import debounce from 'lodash/debounce';

export default {
  name: 'EcsEmailSignatures',
  components: { EcsEmailSignature, EcsEmailSignaturesHeader },
  mounted() {
    this.getOrganizationSignatures();
    this.getSmtpDetails();
  },
  computed: {
    ...mapGetters(['selectedEmailSignature']),
    signature() {
      return this.selectedEmailSignature.signature || '';
    },
    replySignature() {
      return this.selectedEmailSignature.replySignature || '';
    }
  },
  methods: {
    ...mapActions([
      'setSignature',
      'setReplySignature',
      'setSelectedEmailSignature',
      'getOrganizationSignatures',
      'updateEmailSignature',
      'getSmtpDetails'
    ]),
    onSignatureChange: debounce(function(value) {
      this.updateEmailSignature({ field: 'signature', value });
    }, 500),
    onReplySignatureChange: debounce(function(value) {
      this.updateEmailSignature({ field: 'replySignature', value });
    }, 500)
  }
};
</script>

<style scoped>
.email-signatures-card {
  width: 100%;
}
.title {
  text-transform: uppercase;
  color: var(--v-primary-base);
}
</style>
